"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rtl = void 0;
var rtl = exports.rtl = new Set(['ar', 'ckb', 'fa', 'he', 'ur']);
//# sourceMappingURL=rtl.js.map